// extracted by mini-css-extract-plugin
module.exports = {"page-container":"styles_page-container__3MpSk","student-details-grid":"styles_student-details-grid__2wtdh","do-info-box":"styles_do-info-box__2EHWK"};